import { createSlice } from '@reduxjs/toolkit';
import { Device } from '~/utils/interface/device';
import { handleGetDevices } from './deviceThunk';
import _ from 'lodash';
export interface DeviceState {
  devices: Device[];
  selectedDeviceId: number;
  isLoading: boolean;
  needRefreshData: boolean;
}
const initialState: DeviceState = {
  devices: [],
  selectedDeviceId: 0,
  isLoading: false,
  needRefreshData: false,
};
const deviceSlice = createSlice({
  name: 'device',
  initialState,
  reducers: {
    setSelectedDevice: (state, action) => {
      state.selectedDeviceId = action.payload;
    },
    setNeedRefreshData: (state, action) => {
      state.needRefreshData = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetDevices.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(handleGetDevices.fulfilled, (state, action) => {
        if (!_.isEqual(state.devices, action.payload)) {
          state.devices = action.payload;
        }
        state.isLoading = false;
        state.needRefreshData = false;
      })
      .addCase(handleGetDevices.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const deviceActions = deviceSlice.actions;

const deviceReducer = deviceSlice.reducer;
export default deviceReducer;
